import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {Link, useParams, useNavigate} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function IpPatientRegisterNew() {
  const navigate = useNavigate();

  const {pat_id}=useParams();
  const [errorMsg, seterrorMsg] = useState('');
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [gender, setGender] = useState("male");
  const [consData, setConsData] = useState([]);
  const [insurData, setInsurData] = useState([]);
  const [insuranceType, setInsuranceType] = useState('');
  const [succesMsg, setsuccessMsg] = useState('');
  const [patData, setPatData] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const [roomNoData, setRoomNoData] = useState([]);
  const [paymentType, setPaymentType] = useState('Non-insurance');
  const [selectedRoomType, setSelectedRoomType] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [registerFormData, setRegisterFormData] = useState({
        "ip_id":'',
        "pat":'',
        "weight":'',
        "height":'',
        "reltype":'',
        "relname":'',
        "relcontact":'',
        "refered":'',
        "refconsultant":'',
        "condition":'',
        "adhar":'',
        "primary_consult":'',
        "admit_date":'',
        "mlc":'',
        "payment":'',
        "room_no":'',
        "insur_cmpy":'',
        "profile_pic":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchConsData();
  }, []);

  function fetchConsData() {
    axios.get(baseUrl + "cons-search/")
      .then(response => {
        setConsData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchInsurData();
  }, []);

  function fetchInsurData() {
    axios.get(baseUrl + "insur-cmpy/")
      .then(response => {
        setInsurData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchRoomData();
  }, []);

  function fetchRoomData() {
    axios.get(baseUrl + "room-type/")
      .then(response => {
        setRoomData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
   if (selectedRoomType) {
    fetchRoomNoData(selectedRoomType);
   }
  }, [selectedRoomType]);

  const handleRoomTypeChange = (event) => {
    const selectedRoomTypeId = event.target.value;
    setSelectedRoomType(selectedRoomTypeId);
  };

  function fetchRoomNoData(selectedRoomTypeId) {
    axios.get(baseUrl + "room-no/" + selectedRoomTypeId)
      .then(response => {
        setRoomNoData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
   const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
  const handleInputChange = (event) => {
    setGender(event.target.value);
  };

  const inputHandler = (event) => {
  const { name, value } = event.target;

  if (name === 'room_no') {
    const selectedRoomNo = roomNoData.find((roomno) => roomno.id === value);
    const updatedRegisterFormData = { ...registerFormData, [name]: selectedRoomNo };
    setRegisterFormData(updatedRegisterFormData);
  } else {
    const updatedRegisterFormData = { ...registerFormData, [name]: value };
    setRegisterFormData(updatedRegisterFormData);
  }
  };

  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };

  const handleInsuranceTypeChange = (event) => {
    setInsuranceType(event.target.value);
  };
    const handleFileChange = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.files[0]
        });
        const file = event.target.files[0];
        if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
    }

const submitHandler = (e) => {
  e.preventDefault();
  const formData = new FormData();
  const mlc = document.getElementById("mlc").value;
  const refered = document.getElementById("refered").value;
  const referby = document.getElementById("referby").value;
  const reltype = document.getElementById("reltype").value;
  const condition = document.getElementById("condition").value;
  const relname = document.getElementById("relname").value;
  const relcontact = document.getElementById("relcontact").value;
  const primary = document.getElementById("primary").value;
  const room_no = document.getElementById("room_no").value;
  const adhar = document.getElementById("adhar").value;
  const weight = document.getElementById("weight").value;
  const height = document.getElementById("height").value;
  if (!room_no) {
        Swal.fire('Error', 'Please select a Room.', 'error');
        return;
  }

  axios.post(`${baseUrl}get_pat_id/`)
    .then(response => {
      const pat_id = response.data.value;

      axios.post(`${baseUrl}get_ip_id/`)
        .then(response1 => {
          const ipId = response1.data.value;
          formData.append('ip_id', ipId);
          formData.append('my_title', registerFormData.title);
          formData.append('pat_id', pat_id);
          formData.append('patient', registerFormData.patient);
          formData.append('age', registerFormData.age);
          formData.append('marital_status', registerFormData.marital);
          formData.append('address1', registerFormData.address1);
          formData.append('aadhar', registerFormData.adhar);
          formData.append('mobile', registerFormData.mobile);
          formData.append('gender', gender);
          formData.append('weight', weight);
          formData.append('height', height);
          formData.append('reltype', reltype);
          formData.append('relname', relname);
          formData.append('relcontact', relcontact);
          formData.append('refered', refered);
          formData.append('refconsultant', referby);
          formData.append('condition', condition);
          formData.append('adhar', adhar);
          formData.append('primary_consult', primary);

          if (paymentType === 'Insurance') {
            formData.append('payment', paymentType);
            formData.append('insur_cmpy', insuranceType);
          } else {
            formData.append('payment', paymentType);
          }

          if (registerFormData.f_files !== null && registerFormData.f_files !== undefined && registerFormData.f_files !== '') {
            formData.append('profile_pic', registerFormData.f_files, registerFormData.f_files.name);
          }

          formData.append('admit_date', selectedDateTime.toISOString());
          formData.append('mlc', mlc);
          formData.append('room_no', room_no);
          formData.append('addedby', userName);
          formData.append('status', '1');
          formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

          axios.post(baseUrl + 'add-patient/', formData, {
            headers: {
              'content-type': 'multiple/form-data'
            }
          })
            .then((response2) => {
              if (response2.status == 200 || response2.status == 201) {
                const patIds= response2.data.id;
                formData.append('pat', patIds);
                axios.post(`${baseUrl}add-ip-admit/`, formData)
                  .then(response3 => {
                    if (response3.status == 200 || response3.status == 201) {
                      const ip_id = response3.data.id;
                      formData.append('ip', ip_id);
                      formData.append('addedby', userName);
                      formData.append('status', '1');
                      formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);
                      axios.post(`${baseUrl}ip-consult-create/`, formData)
                        .then(response4 => {
                          Swal.fire({
                            title: 'In-Patient Registration Done.',
                            icon: 'success',
                            timer: 5000,
                            showConfirmButton: false
                          });
                        });

                      setTimeout(() => {
                        window.location.href = '/confirm-ip-admit/' + response3.data.id + '/';
                      }, 3000);
                    }
                  })
                  .catch(error => {
                    console.log(error);
                    Swal.fire(
                      'Error!',
                      'Failed to add min entry. Please try again later.',
                      'error'
                    );
                  });
              }
            });
        });
    });
};


  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-10 col-12 offset-1">
                <div className='card'>
                    <h4 className='card-header text-center'>IP Patient Registration</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>
                        <div>
                        <div className="row">
                        <label htmlFor="Role" className="form-label">Patient Name</label>
                        <div className="col-md-2 mb-3">
                              <select className="form-control"
                              value={registerFormData.title}
                              onChange={inputHandler}
                                name="title" id="title">
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Master">Master</option>
                                <option value="Dr">Dr</option>
                                <option value="Baby">Baby</option>
                                <option value="Ms">Ms</option>
                              </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <input type="hidden"  className="form-control"
                           name="patId"
                           value={registerFormData.id}
                           onChange={inputHandler} />
                       <input type="text" placeholder="Patient Name" className="form-control"
                           name="patient"
                           value={registerFormData.patient}
                           onChange={inputHandler}
                           
                           />
                        </div>
                        <div className="col-md-4 mb-3">
                        <label htmlFor="Gender" className="form-label">Gender</label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="male" checked={gender === "male"}
                             onChange={handleInputChange}/> Male
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="female" checked={gender === "female"}
                             onChange={handleInputChange} /> Female
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="transgender" checked={gender === "transgender"}
                             onChange={handleInputChange} /> Transgender
                            </label>
                        </div>
                        <div className="col-md-3 mb-2">
                        {selectedImage && (
                        <>
                        <img src={selectedImage} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/>
                        </>
                        )}
                        <input type="file" className="form-control" name="f_files"
                        onChange={handleFileChange} id="f_files" accept="image/*"/>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Age" className="form-label">Age</label>
                            <input type="text" placeholder="Age" className="form-control"
                               name="age"
                               value={registerFormData.age}
                               onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Mobile" className="form-label">Mobile</label>
                            <input type="number" maxLength={10} placeholder="Mobile" className="form-control"
                                name="mobile"
                                value={registerFormData.mobile}
                                onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Address" className="form-label">Address</label>
                            <input type="text" placeholder="Address" className="form-control"
                               name="address1"
                               value={patData.length > 0 && patData[0].address1 !== undefined ? patData[0].address1 : registerFormData.address1}
                               onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Marital" className="form-label">Marital Status</label>
                            <select className="form-control"
                            value={registerFormData.marital}
                            onChange={inputHandler}
                              name="marital" id="marital" >
                            <option value="single">Single</option>
                            <option value="married">Married</option>
                            <option value="unmarried">Un Married</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Blood Group" className="form-label">Blood Group</label>
                            <select className="form-control"
                            value={registerFormData.blood}
                            onChange={inputHandler}
                              name="blood" id="blood" >
                            <option value="O+">O+</option>
                            <option value="O-">O-</option>
                            <option value="B+">B+</option>
                            <option value="B-">B-</option>
                            <option value="A+">A+</option>
                            <option value="A-">A-</option>
                            <option value="AB+">AB+</option>
                            <option value="AB-">AB-</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Weight" className="form-label">Weight</label>
                        <input type="number" maxLength={10} placeholder="Weight" className="form-control"
                            name="weight" id="weight"
                            onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Height" className="form-label">Height</label>
                        <input type="number" maxLength={10} placeholder="Height" className="form-control"
                            name="height" id="height"
                            onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Aadhar" className="form-label">Aadhar</label>
                            <input type="number" placeholder="Aadhar" className="form-control" maxLength={16}
                               name="adhar" id="adhar" value={registerFormData.adhar} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Date" className="form-label">Admission Date</label>
                        <DatePicker className="form-control" name="admit_date" id="admit_date" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Condition" className="form-label">Patient Condition</label>
                            <select className="form-control" value={registerFormData.condition} onChange={inputHandler}
                              name="condition" id="condition">
                            <option value="Medical">Medical Management</option>
                            <option value="Surgical">Surgical Management</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="MLC" className="form-label">MLC</label>
                            <select className="form-control" value={registerFormData.mlc} onChange={inputHandler}
                              name="mlc" id="mlc">
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Refered" className="form-label">Referred Type</label>
                            <select className="form-control" value={registerFormData.refered} onChange={inputHandler}
                              name="refered" id="refered">
                            <option value="walkin">Walk-in</option>
                            <option value="medicalcamp">Medical Campaign</option>
                            <option value="friends">Friends</option>
                            <option value="doctor">Doctor</option>
                            <option value="paperad">Paper Adv</option>
                            <option value="others">Others</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="referby" className="form-label">Referred By</label>
                            <input type="text" placeholder="Reference" className="form-control"
                               name="referby" id="referby" value={registerFormData.referby} onChange={inputHandler} />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label htmlFor="Rel name" className="form-label">Relation Name</label>
                            <input type="text" placeholder="Relation Name" className="form-control"
                               name="relname" id="relname" value={registerFormData.relname} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Rel Contact" className="form-label">Relation Contact</label>
                            <input type="number" placeholder="Relation Contact" className="form-control"
                               name="relcontact" id="relcontact" value={registerFormData.relcontact} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Rel type" className="form-label">Relation Type</label>
                            <select className="form-control" value={registerFormData.reltype} onChange={inputHandler}
                              name="reltype" id="reltype">
                            <option value="Father">Father</option>
                            <option value="Mother">Mother</option>
                            <option value="Son">Son</option>
                            <option value="Daughter">Daughter</option>
                            <option value="Brother">Brother</option>
                            <option value="Sister">Sister</option>
                            <option value="Husband">Husband</option>
                            <option value="Wife">Wife</option>
                            <option value="Uncle">Uncle</option>
                            <option value="Aunty">Aunty</option>
                            <option value="Attender">Attender</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="primary" className="form-label">Primary Consultant</label>
                          <select className="form-control" value={registerFormData.primary} onChange={inputHandler}
                                name="primary" id="primary">
                                {consData.map((cons,index) => {return <option key={index} value={cons.id}>{cons.consultant}
                                </option>})}
                              </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Condition" className="form-label">Payment Type</label>
                            <select className="form-control" value={paymentType} onChange={handlePaymentTypeChange}
                              name="ptype" id="ptype"><option >Select</option>
                            <option value="Non-insurance">Non-Insurance</option>
                            <option value="Insurance">Insurance</option>
                            </select>
                        </div>
                        {paymentType === 'Insurance' && (
                        <div className="col-md-3 mb-3">
                        <label htmlFor="insurtype" className="form-label">Insurance Type</label>
                          <select className="form-control" value={insuranceType} onChange={handleInsuranceTypeChange}
                                name="insurtype" id="insurtype" >
                                  <option >Select</option>
                                {insurData.map((insur,index) => {return <option key={index} value={insur.id}>{insur.type.type} - {insur.company}
                                </option>})}
                              </select>
                        </div>
                        )}
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="room" className="form-label">Room Type</label>
                            <select
                              className="form-control"
                              value={selectedRoomType}
                              name="room"
                              id="room"
                              onChange={handleRoomTypeChange}
                            >
                              <option>Select Room Type </option>
                              {roomData.map((room, index) => (
                                <option key={index} value={room.id}>
                                  {room.room}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-3 mb-3">
                            <label htmlFor="room_no" className="form-label">Room No</label>
                            <select className="form-control" value={registerFormData.room_no} name="room_no" id="room_no" onChange={inputHandler}>
                              {roomNoData.map((roomno, index) => (
                                <option key={index} value={roomno.id}>
                                  {roomno.room_no}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" onClick={submitHandler}
                        className="btn btn-success">Register</button>
                        </div>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default IpPatientRegisterNew;
